import get from 'lodash/get'

/**
 * hasFeature()
 *
 * Feature checks read `features` as-is - any per-user role override is
 * already baked in by the time `features` gets here (see `withConfig` and
 * `applyFeatureRoleOverrides` in `./featureRoleOverrides.js`), so call sites
 * never need to know about it.
 *
 * @param {object} features - feature set configuration
 * @param {string} feature - required feature (using `semmicolon:seperated:form`)
 */
export const hasFeature = (features, feature) => !!get(features, feature.replace(/:/g, '.'))
